import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import {
  signUp,
  sendGoogleOAuthCode,
  googleOAuthRedirect,
  resetEmailError,
  setEmailInputToDanger,
  load as loadAuth,
} from 'redux/modules/auth';
import Panel from 'components/Panel/Panel';
import {
  ControlLabel,
  FormControl,
  FormGroup,
  Form,
  Col,
  Button,
  HelpBlock,
} from 'react-bootstrap';
import cookie from 'react-cookie';
import { withRouter } from 'react-router';
import GoogleButton from 'components/Post/PostSelectRole/GoogleButton';
import Separator from 'components/Shared/Separator/Separator';
import Recaptcha from 'react-google-invisible-recaptcha';

import EmailInput from 'components/SignUp/EmailInput';
import AccountTypeInput from 'components/SignUp/AccountTypeInput.js';
import SvgIcon from 'components/SvgIcon/SvgIcon';
import styles from './Signup.module.scss';
import Loader from 'components/Loader/Loader';

@connect(
  (state) => ({
    emailError: state.auth.emailError,
    passwordError: state.auth.passwordError,
    usernameError: state.auth.usernameError,
    accountTypeError: state.auth.accountTypeError,
    emailValidationType: state.auth.emailValidationType,
    signedUpToGoogle: state.auth.signedUpToGoogle,
    signingUpViaGoogle: state.auth.signingUpViaGoogle,
    googleSignUpFailed: state.auth.googleSignUpFailed,
  }),
  {
    signUp,
    loadAuth,
    setEmailInputToDanger,
    resetEmailError,
    googleOAuthRedirect,
    sendGoogleOAuthCode,
  }
)
@withRouter
class SignUp extends Component {
  static propTypes = {
    location: PropTypes.object,
    history: PropTypes.object,
    signUp: PropTypes.func,
    loadAuth: PropTypes.func,
    emailError: PropTypes.array,
    passwordError: PropTypes.array,
    usernameError: PropTypes.array,
    accountTypeError: PropTypes.array,
    emailValidationType: PropTypes.string,
    setEmailInputToDanger: PropTypes.func,
    resetEmailError: PropTypes.func,
    googleOAuthRedirect: PropTypes.func,
    sendGoogleOAuthCode: PropTypes.func,
    signedUpToGoogle: PropTypes.bool,
    signingUpViaGoogle: PropTypes.bool,
    redirect: PropTypes.string,
    redirectFromGoogle: PropTypes.string,
    defaultAccountType: PropTypes.string,
    googleSignUpFailed: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      username: '',
      email: '',
      password: '',
      type: '',
      errors: {},
      shouldRedirect: false,
      hasTriedToContinue: false,
      hide: false,
      showTypeError: false,
      disableSubmitButton: true,
      toRender: null,
    };
  }

  componentDidMount() {
    const { location } = this.props;
    this.handleGoogleOauthCode();
    if (location.query.email) {
      this.setState({
        email: location.query.email,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { signedUpToGoogle } = this.props;
    const { username, email, password, type } = this.state;
    const {
      username: prevUsername,
      email: prevEmail,
      password: prevPassword,
      type: prevType,
    } = prevState;

    if (!prevProps.signedUpToGoogle && signedUpToGoogle) {
      this.loginAndRedirect();
    }

    // Login Input change
    if (
      username !== prevUsername ||
      email !== prevEmail ||
      password !== prevPassword ||
      type !== prevType
    ) {
      let result = this.handleValidation();
      this.setState({ disableSubmitButton: !result });
    }
  }

  saveLocalUserType = () => {
    const { type } = this.state;
    try {
      localStorage.setItem('userType', JSON.stringify({ type }));
    } catch (error) {
      console.warn('Unable to save user type locally.', error.message);
    }
  };

  saveLocalAICollectorData = () => {
    const { isCollector, shouldRedirect } = this.state;
    try {
      localStorage.setItem('isCollector', JSON.stringify({ isCollector }));
      localStorage.setItem(
        'shouldRedirect',
        JSON.stringify({ shouldRedirect })
      );
    } catch (error) {
      console.warn(
        'Unable to save isCollector/ shouldRedirect locally.',
        error.message
      );
    }
  };

  retrieveLocalUserType = () => {
    let type = 'seller';
    try {
      type = JSON.parse(localStorage.getItem('userType')).type;
    } catch (error) {
      console.warn('Unable to retrieve local user type.', error.message);
    }
    return type;
  };

  retrieveLocalIsCollector = () => {
    if (!__CLIENT__) {
      return false;
    }
    let isCollector = false;
    try {
      isCollector = JSON.parse(localStorage.getItem('isCollector')).isCollector;
    } catch (error) {
      console.warn('Unable to retrieve local isCollector.', error.message);
    }
    return isCollector;
  };

  retrieveLocalShouldRedirect = () => {
    if (!__CLIENT__) {
      return false;
    }
    let shouldRedirect = false;
    try {
      shouldRedirect = JSON.parse(
        localStorage.getItem('shouldRedirect')
      ).shouldRedirect;
    } catch (error) {
      console.warn('Unable to retrieve local shouldRedirect.', error.message);
    }
    return shouldRedirect;
  };

  handleGoogleOauthCode() {
    const googleOauthCode = this.isGoogleOAuthCode();
    if (googleOauthCode) {
      this.setState({ toRender: 'loader' });
      const { sendGoogleOAuthCode } = this.props;
      const type = this.retrieveLocalUserType();
      const redirect = 'signup';
      const aiCollector = this.retrieveLocalIsCollector();
      sendGoogleOAuthCode(googleOauthCode, redirect, type, aiCollector);
    } else {
      this.setState({ toRender: 'signup' });
    }
  }

  isGoogleOAuthCode() {
    const urlString = window.location.href;
    const url = new URL(urlString);
    return url.searchParams.get('code');
  }

  resetHasTriedToContinue = () => {
    this.setState({
      hasTriedToContinue: false,
    });
  };

  handleSubmit = async (event) => {
    event.preventDefault();

    const signUpDetails = {
      email: this.state.email,
      password: this.state.password,
      type: this.state.type,
      username: this.state.username,
      utm: {},
      ai_collector: this.state.isCollector,
    };

    if (typeof cookie.load('utm_source') !== 'undefined') {
      signUpDetails.utm.source = cookie.load('utm_source');
    }

    if (typeof cookie.load('utm_medium') !== 'undefined') {
      signUpDetails.utm.medium = cookie.load('utm_medium');
    }

    if (typeof cookie.load('utm_campaign') !== 'undefined') {
      signUpDetails.utm.campaign = cookie.load('utm_campaign');
    }

    if (typeof cookie.load('utm_term') !== 'undefined') {
      signUpDetails.utm.term = cookie.load('utm_term');
    }

    if (typeof cookie.load('utm_content') !== 'undefined') {
      signUpDetails.utm.content = cookie.load('utm_content');
    }

    if (this.recaptcha) {
      this.setState(
        { signUpDetails, emailError: null, passwordError: null },
        () => {
          this.recaptcha.execute();
        }
      );
    } else {
      this.handleValidationSignUpAndLogin(signUpDetails);
    }
    if (this.recaptcha) {
      this.recaptcha.reset();
    }
  };

  handleValidationSignUpAndLogin = async (signUpDetails) => {
    if (
      this.props.emailValidationType === 'Invalid' &&
      !this.state.hasTriedToContinue
    ) {
      this.setState({
        hasTriedToContinue: true,
      });
      this.props.setEmailInputToDanger();
    } else {
      if (this.handleValidation()) {
        await this.props.signUp(signUpDetails);
        if (
          this.props.redirect &&
          this.props.emailError.length === 0 &&
          this.props.passwordError.length === 0 &&
          this.props.usernameError.length === 0 &&
          this.props.accountTypeError.length === 0
        ) {
          this.loginAndRedirect();
        }
      }
    }
  };

  handleRecaptchaResolved = async () => {
    const signUpDetails = this.state;

    signUpDetails['ai_collector'] = this.state.isCollector;

    signUpDetails.recaptcha = this.recaptcha.getResponse();

    await this.handleValidationSignUpAndLogin(signUpDetails);

    this.setState({ signUpDetails: null });
  };

  loginAndRedirect = async () => {
    await this.props.loadAuth();
    this.setState({ shouldRedirect: true });
  };

  usernameValidation = () => {
    const { username } = this.state;
    const { usernameError } = this.props;
    const usernameRegex = /^[a-zA-Z0-9]+$/;

    const handleUsernameError = (errorMessage) => {
      usernameError.length = 0;
      usernameError.push(errorMessage);
    };

    if (username.length < 4) {
      handleUsernameError('Username must be atleast 4 characters');
      return false;
    }

    if (!usernameRegex.test(username)) {
      handleUsernameError('Username should only contain letters and numbers');
      return false;
    }

    if (username.length > 20) {
      handleUsernameError('Username must not be more than 20 characters');
      return false;
    }

    usernameError.length = 0;
    return true;
  };

  passwordValidation = () => {
    const { password, username } = this.state;
    const { passwordError } = this.props;

    const handlePasswordError = (errorMessage) => {
      passwordError.length = 0;
      passwordError.push(errorMessage);
    };

    if (password.length < 8) {
      handlePasswordError('Your password must be more than 8 characters');
      return false;
    }

    if (password === username) {
      handlePasswordError('Your password cannot be the same as your username');
      return false;
    }

    passwordError.length = 0;
    return true;
  };

  typeValidation = () => {
    const { type } = this.state;
    const { accountTypeError, defaultAccountType } = this.props;

    if (type === '' && !defaultAccountType) {
      accountTypeError.length = 0;
      accountTypeError.push('Please select account type');
      return false;
    }

    accountTypeError.length = 0;
    return true;
  };

  emailValidation = () => {
    const { email } = this.state;
    const { emailError } = this.props;

    const handleEmailError = (errorMessage) => {
      emailError.length = 0;
      emailError.push(errorMessage);
    };

    if (email === '') {
      handleEmailError('Please enter your email address');
      return false;
    }

    if (!email.includes('@') || !email.includes('.')) {
      handleEmailError("Email doesn't contain @ or .");
      return false;
    }

    emailError.length = 0;
    return true;
  };

  handleValidation = () => {
    let result = true;

    result =
      this.usernameValidation() &&
      this.typeValidation() &&
      this.emailValidation() &&
      this.passwordValidation();

    if (result === false) {
      this.setState(this.state);
    }
    return result;
  };

  handlePasswordChange = (event) => {
    this.setState({ password: event.target.value });
  };

  handleUsernameChange = (event) => {
    this.setState({ username: event.target.value });
  };

  handleEmailChange = (event) => {
    this.setState({
      email: event.target.value,
      hasTriedToContinue: false,
    });
    if (this.state.email.includes('@') && this.state.email.includes('.')) {
      this.props.resetEmailError();
    }
  };

  handleTypeChange = (event) => {
    event.target.value === 'collector'
      ? this.setState({ type: 'seller', isCollector: true })
      : this.setState({ type: event.target.value, isCollector: false });
  };

  handleGoogleButtonClick = (redirect) => {
    if (this.state.hide && this.state.type.length < 1) {
      this.props.accountTypeError.length = 0;
      this.props.accountTypeError.push('Please select account type');
      this.setState({ showTypeError: true });
      return;
    }

    if (this.state.type.length < 1) {
      this.setState({ hide: true });
      return;
    }

    this.saveLocalUserType();
    this.saveLocalAICollectorData();
    this.props.googleOAuthRedirect(redirect);
  };

  render() {
    const { shouldRedirect, isCollector, disableSubmitButton } = this.state;
    const googleShouldRedirect = this.retrieveLocalShouldRedirect();
    const googleIsCollector = this.retrieveLocalIsCollector();
    const {
      emailError,
      history,
      passwordError,
      usernameError,
      redirectFromGoogle,
      accountTypeError,
      location,
      googleSignUpFailed,
    } = this.props;
    const type = location.query.type;

    const redirect = this.props.redirect ? this.props.redirect : '/';
    const defaultAccountType = this.props.defaultAccountType
      ? this.props.defaultAccountType
      : type
      ? type
      : null;

    if (shouldRedirect || googleShouldRedirect) {
      if (isCollector || googleIsCollector) {
        history.push(`/${redirect}/microprojects?type=collector`);
      } else {
        history.push(`/${redirect}`);
      }
    }

    return (
      <Panel className={styles.signUpPanel}>
        {this.state.toRender === 'loader' && !googleSignUpFailed && (
          <>
            <Loader loading={true} />
            <div> Google login succesful, redirecting... </div>{' '}
          </>
        )}
        {(this.state.toRender === 'signup' || googleSignUpFailed) && (
          <>
            <Form horizontal style={this.state.hide ? { display: 'none' } : {}}>
              <FormGroup key={1} controlId="signup-username">
                <Col sm={3} className={styles.formLabel}>
                  <ControlLabel>Username:</ControlLabel>
                </Col>
                <Col sm={9}>
                  <FormControl
                    type="username"
                    className={styles.formField}
                    placeholder="Username"
                    value={this.state.username}
                    onChange={(event) => this.handleUsernameChange(event)}
                    maxLength={20}
                  />
                  {usernameError && usernameError.length > 0 && (
                    <HelpBlock className={styles.helpBlock}>
                      {usernameError}
                    </HelpBlock>
                  )}
                </Col>
              </FormGroup>
              <FormGroup key={2} controlId="signup-usertype">
                <Col sm={3} className={styles.formLabel}>
                  <div className={styles.labelContainer}>
                    <ControlLabel>Account type:</ControlLabel>
                  </div>
                </Col>
                <Col sm={9}>
                  <AccountTypeInput
                    onChange={(event) => this.handleTypeChange(event)}
                    accountTypeError={accountTypeError}
                    defaultAccountType={defaultAccountType}
                    styles={styles}
                  />
                </Col>
              </FormGroup>
              <FormGroup controlId="signup-email">
                <Col sm={3} className={styles.formLabel}>
                  <div className={styles.labelContainer}>
                    <ControlLabel>Email address:</ControlLabel>
                  </div>
                </Col>
                <Col sm={9}>
                  <EmailInput
                    type="email"
                    placeholder="e.g. name@company.com"
                    styles={styles}
                    disabled={false}
                    value={this.state.email}
                    onChange={(event) => this.handleEmailChange(event)}
                    className={styles.formField}
                    isInPost={false}
                    resetContinue={this.resetHasTriedToContinue}
                    maxLength={255}
                  />
                  {emailError && emailError.length > 0 && (
                    <HelpBlock className={styles.helpBlock}>
                      {emailError}
                    </HelpBlock>
                  )}
                </Col>
              </FormGroup>
              <FormGroup controlId="signup-password">
                <Col sm={3} className={styles.formLabel}>
                  <ControlLabel>Password:</ControlLabel>
                </Col>
                <Col sm={9}>
                  <FormControl
                    type="password"
                    className={styles.formField}
                    placeholder="Your password must be more than 8 characters"
                    value={this.state.password}
                    onChange={(event) => this.handlePasswordChange(event)}
                    maxLength={50}
                  />
                  {passwordError && passwordError.length > 0 && (
                    <HelpBlock className={styles.helpBlock}>
                      {passwordError}
                    </HelpBlock>
                  )}
                </Col>
              </FormGroup>
              <p className={styles.termsText}>
                By signing up, you agree to our <a href="/terms">Terms</a>.
              </p>
              <FormGroup>
                <div className={styles.signUpContainer}>
                  <Button
                    className={`${styles.signUpButton} lato-bold`}
                    bsStyle="primary"
                    bsSize="lg"
                    type="submit"
                    disabled={disableSubmitButton}
                    onClick={(event) => this.handleSubmit(event)}
                  >
                    <div className={styles.signUpCTA}>
                      <span className={styles.signUpCopy}>Sign up</span>
                      <SvgIcon icon="chevron-right" size="14" />
                    </div>
                  </Button>
                </div>
              </FormGroup>
            </Form>
            <div style={this.state.hide ? { display: 'none' } : {}}>
              <Separator text="OR" />
            </div>
            <br />
            <Form horizontal style={this.state.hide ? {} : { display: 'none' }}>
              <FormGroup controlId="signup-usertype2">
                <Col sm={3} className={styles.formLabel}>
                  <ControlLabel>Account type:</ControlLabel>
                </Col>
                <Col sm={9}>
                  <AccountTypeInput
                    onChange={(event) => this.handleTypeChange(event)}
                    accountTypeError={accountTypeError}
                    styles={styles}
                  />
                </Col>
              </FormGroup>
              <br />
            </Form>
            <div>
              <GoogleButton
                googleOAuthRedirect={this.handleGoogleButtonClick}
                redirect={redirectFromGoogle}
              />
            </div>
            <br />
            <hr />
            <div style={{ textAlign: 'center' }}>
              <span>
                Already have an account? <a href="/signin">Sign in</a>
              </span>
            </div>
            {process.env.GOOGLE_RECAPTCHA_API_KEY && (
              <Recaptcha
                ref={(ref) => (this.recaptcha = ref)}
                sitekey={process.env.GOOGLE_RECAPTCHA_API_KEY}
                onResolved={this.handleRecaptchaResolved}
              />
            )}
          </>
        )}
      </Panel>
    );
  }
}

export default SignUp;
